import { WeatherSettingsChangeSource } from '@fe/weather';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { Checkbox, RadioGroup } from '@progress/kendo-react-inputs';
import { MinimumEchoTopsNexrad, MinimumLevelNexrad, MinimumRainfallNexrad, RadarSummaryArrowStyleOptions } from '../settings-options';
import { useBooleanSetting, useDropdownSetting, useRadioGroupSetting, useSliderSetting } from './hooks/useSetting';
import SettingsSubSection from '../../../common/SettingsSubSection';
import { SliderWithTooltip } from '../../../../app/components/inputs/SliderWithTooltip';

export default function RadarSettings() {
    const nexradMin = useDropdownSetting(MinimumLevelNexrad, 'radar', 'nexradMinLevel', WeatherSettingsChangeSource.radarSatellite);
    const nexradRainfallMin = useDropdownSetting(
        MinimumRainfallNexrad,
        'radar',
        'nexradRainfallMinLevel',
        WeatherSettingsChangeSource.radarSatellite
    );
    const nexradEchoTopsMin = useDropdownSetting(
        MinimumEchoTopsNexrad,
        'radar',
        'nexradEchoTopsMinLevel',
        WeatherSettingsChangeSource.radarSatellite
    );

    const radarSmoothing = useBooleanSetting('radar', 'radarSmoothing', WeatherSettingsChangeSource.radarSatellite);
    const showSpeedLabel = useBooleanSetting('radar', 'radarSummaryShowSpeedLabel', WeatherSettingsChangeSource.radarSummary);
    const arrowStyle = useRadioGroupSetting(
        RadarSummaryArrowStyleOptions,
        'radar',
        'radarSummarySpeedArrowStyle',
        WeatherSettingsChangeSource.radarSummaryStyle
    );
    const transparency = useBooleanSetting('radar', 'enableRadarTransparency', WeatherSettingsChangeSource.radarSatellite);
    const transparencyValue = useSliderSetting('radar', 'radarTransparency', WeatherSettingsChangeSource.radarSatellite);

    return (
        <div className="d-flex gap-2 flex-column">
            <SettingsSubSection title="NEXRAD">
                <div>
                    <div>Min level to display:</div>
                    <DropDownList {...nexradMin} />
                    <Checkbox {...radarSmoothing} className="py-2" label="Radar smoothing" />
                </div>

                <div>
                    <div>Rainfall estimate min level to display</div>
                    <DropDownList {...nexradRainfallMin} />
                </div>

                <div>
                    <div>Echo tops min level to display</div>
                    <DropDownList {...nexradEchoTopsMin} />
                </div>

                <div className="d-flex gap-2 align-items-center">
                    <Checkbox {...transparency} label={'Enable transparency'} />
                    <SliderWithTooltip min={0} max={100} {...transparencyValue} className="flex-grow-1" />
                </div>
            </SettingsSubSection>
            <SettingsSubSection title="Radar summary">
                <div className="d-flex gap-2">
                    <span>Style:</span>
                    <RadioGroup {...arrowStyle} layout="horizontal" />
                </div>
                <Checkbox {...showSpeedLabel} label={'Show speed label'} />
            </SettingsSubSection>
        </div>
    );
}
